export default "__VITE_ASSET__K_aRTf8D__"